import { createClient } from "@supabase/supabase-js";
export const configured = Boolean(
  import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY,
);
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || "http://127.0.0.1:54321",
  import.meta.env.VITE_SUPABASE_ANON_KEY || "unconfigured-public-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
/** The signed-in user from this device's session. Unlike auth.getUser() it doesn't ask the auth
 * server, so loaders skip a round trip; row-level security still checks every query. */
export async function sessionUser() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.user ?? null;
}
/** Who the session saved on this device belongs to, read without waiting for a token refresh.
 * Only for showing that account's own cached data sooner; requests still use the real session. */
export function storedSessionUserId(): string | null {
  try {
    const raw = localStorage.getItem((supabase.auth as unknown as { storageKey: string }).storageKey);
    const id = raw ? JSON.parse(raw)?.user?.id : null;
    return typeof id === "string" ? id : null;
  } catch { return null; }
}
